<template>
    <v-dialog v-model="dialog" width="100%"  style="margin: 100px !important;" persistent class="custom-dialog">
        <v-card>
            <v-card-title>
                <span class="text-h5">
                    Lançamento de Parcelas {{ selectedProject?.valorJob 
                        ? '(' + selectedProject?.valorJob.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                            })
                        + ')' || 0 : '' }}
                </span>
            </v-card-title>

            <div style="padding: 20px">
                <div class="d-flex ga-3">
                    <div class="job-search-container">
                        <span class="text-small">
                            Selecione um JOB
                        </span>
                        <v-autocomplete
                            v-model="selectedProject"
                            :items="projectItems"
                            item-text="code"
                            item-value="id"
                            class="w-50 job-field"
                            clearable
                            hide-details
                            hide-selected
                            label="JOB"
                            outlined
                            @blur="verifySelectedProject"
                            return-object
                        />
                    </div>

                    <div class="tot-field-container">
                        <span class="text-small">
                            Total
                        </span>
                        <v-text-field
                            type="text"
                            :readonly="true"
                            :disabled="true"
                            dense
                            hide-details
                            outlined
                            clearable
                            hide-selected
                            :value="totValue.toLocaleString('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL'
                                        })"
                        />
                    </div>
                </div>
                    
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th width="5"></th>
                            <th width="5">Parcela</th>
                            <th>Tipo</th>
                            <th>Descrição</th>
                            <th>Dias</th>
                            <th>Data Vencimento</th>
                            <th>Percentual</th>
                            <th>Valor</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in itemsParcelas" :key="index">
                            <td width="5">
                                <v-btn @click="removeItemParcela(item, index)" v-if="index !== itemsParcelas.length - 1" :color="'red'" icon smal>
                                    <v-icon>
                                        mdi-delete
                                    </v-icon>
                                </v-btn>
                                <v-btn @click="addItemParcela(item)" v-else :color="'primary'" icon smal :disabled="verifySumParcelas">
                                    <v-icon>
                                        mdi-plus
                                    </v-icon>
                                </v-btn>
                            </td>
                            <td class="pa-5" width="5">
                                {{  index + 1 }}
                            </td>
                            <td>
                                <v-combobox 
                                    v-model="item.tipo"
                                    :items="['PV', 'NF']"
                                    dense
                                    hide-details
                                    outlined
                                    label="Tipo"
                                />
                            </td>
                            <td class="pa-5">
                                <v-combobox
                                    v-model="item.descricao"
                                    :items="descriptionOptions"
                                    dense
                                    hide-details
                                    outlined
                                    label="Descrição"
                                />
                            </td>
                            <td class="pa-5">
                                <v-text-field
                                    v-model="item.parcelaDias"
                                    type="number"
                                    dense
                                    hide-details
                                    outlined
                                    label="Dias"
                                    @blur="calcDays(item)"
                                />
                            </td>
                            <td class="pa-5">
                                <v-text-field
                                    v-model="item.dataVencimento"
                                    dense
                                    hide-details
                                    type="date"
                                    outlined
                                    label="Data Vencimento"
                                    @blur="calcDaysDate(item)"
                                />
                            </td>
                            <td class="pa-5">
                                <v-text-field
                                    :key="componentKey"
                                    v-model="item.parcelaPorcentagem"
                                    type="text"
                                    dense
                                    hide-details
                                    outlined
                                    suffix="%"
                                    label="Percentual"
                                    :max="100"
                                    @blur="calcPercentage(item)"
                                />
                            </td>
                            <td class="pa-5">
                                <v-text-field
                                :key="componentKey"
                                v-money="money"
                                v-model="item.vrlParcela"
                                dense
                                hide-details
                                outlined
                                label="Valor da Parcela"
                                @blur="calcValue(item)"
                                />
                            </td>
                            <td class="pa-5"></td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </div>
            
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="$emit('cancel')">
                    Cancelar
                </v-btn>
                
                <v-btn color="blue darken-1" text @click="save">
                    Salvar
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
import Vue from 'vue';
import EntityService from "@/services/entityService.js";
import moment from 'moment';
import {VMoney} from 'v-money'

export default {
    name: 'ScheduleAddView',
    props: {
        open: {
            type: Boolean,
            default: false
        }
    },
    directives: { money: VMoney },
    data() {
        return {
            entityService: new EntityService('Project'),
            entityServiceParcelas: new EntityService('Parcelas'),
            dialog: false,
            projectItems: [],
            selectedProject: null,
            itemsParcelas: [],
            totValue: 0,
            money: {
                locale: "pt-br",
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                precision: 2,
                masked: false
            },
            componentKey: 0,
            descriptionOptions: [
                'Com pedido de compra',
                'Com aprovação dos desenhos',
                'Com compra da MP',
                'Com entrega dos equipamentos',
                'Com aceite final'
            ]
        }
    },
    computed: {
        verifySumParcelas(){

            if(this.selectedProject?.valorJob){
                let sum = 0
                this.itemsParcelas.forEach((el) => {
                    const rawValue = Number(
                        String(el.vrlParcela)
                        .replace(/[^0-9,-]+/g, '')
                        .replace('.', '')
                        .replace(',', '.')
                    )
                    sum += (rawValue)
                })

                return sum >= this.selectedProject?.valorJob
            }

            return true
        }
    },
    methods: {

        async getJobs() {
            let data = await this.entityService.getAll(1, 10000, '', '', '', '', '')
            this.projectItems = data.data.data.data
        },

        async getJobCode(){
            let autoInc = await this.entityService.autoInc('Parcelas', 'Code', '######')
            return autoInc.data
        },

        async addItemParcela(item){

            let code = await this.getJobCode()

            this.itemsParcelas.push({
                code: code,
                tipo: 'PV',
                //parcelaSequencia: item.parcelaSequencia + 1,
                descricao: '',
                parcelaDias: 0,
                dataVencimento: '',
                dataPrevisao: '',
                parcelaPorcentagem: 0,
                vrlParcela: '',
            })
        },
        
        removeItemParcela(item, index) {
            this.itemsParcelas.splice(index, 1);
        },

        getTypeOculto (option) {
            switch(option) {
                case 'Com pedido de compra':
                    return 'AD'
                case 'Com aprovação dos desenhos':
                    return 'AD'
                case 'Com compra da MP':
                    return 'AD'
                case 'Com entrega dos equipamentos':
                    return 'NF'
                case 'Com aceite final':
                    return 'NF'
            }
        },

        async save() {
            if(this.selectedProject === null){
                this.$notfy.error("Selecione um JOB.");
                return
            }

            let sum = 0
            this.itemsParcelas.forEach((el) => {
                const rawValue = Number(
                    String(el.vrlParcela)
                    .replace(/[^0-9,-]+/g, '') // remove R$, espaços etc
                    .replace('.', '')
                    .replace(',', '.')
                )
                sum += (rawValue)
            })

            if(sum > this.selectedProject.valorJob){
                this.$notfy.error("A soma das parcelas não pode ultrapassar o valor do JOB");
                return
            }

            const newsParcelas = this.itemsParcelas.map((item, index) => {
                console.log('ITEM >>> ', item)
                const vrlParcela = Number(
                    String(item.vrlParcela)
                    .replace(/[^0-9,-]+/g, '')
                    .replace('.', '')
                    .replace(',', '.')
                )

                
                return {
                    ...item,
                    parcelaSequencia: index + 1,
                    job: this.selectedProject.id,
                    tipoOculto: item.descricao ? this.getTypeOculto(item.descricao) : 'NF',
                    valorRecebido: 0,
                    parcelaPorcentagem: 
                        isNaN(item.parcelaPorcentagem) ? Number(item.parcelaPorcentagem?.replaceAll(',', '.')) : Number(item.parcelaPorcentagem),
                    valorParaReceber: vrlParcela,
                    vrlParcela: vrlParcela
                }

            })


            let parcelasPost = newsParcelas.filter((item) => !item.id)
            let parcelasPut = newsParcelas.filter((item) => item.id)

            if (parcelasPut.length) {
                await Vue.prototype.$http.put('/Entity/updateMany/Parcelas', parcelasPut)
            }
            
            let response = { data: { success: true } }

            if (parcelasPost.length) {
                response = await Vue.prototype.$http.post('/Entity/insertMany/Parcelas', parcelasPost)

                await Vue.prototype.$http.post('/Entity/insertMany/Alert', 
                    [{
                        title: `Realizar Fluxo de Caixa`,
                        description: `Foram realizadas lançamento de parcelas para o job ${this.selectedProject.code}`,
                        link: '',
                        view: 'Não',
                        schemaRecordId: this.selectedProject.id,
                        user: '46af51fa-18f0-49b8-a1f1-57fbc9f4c95c' // Roberto dos Santos Romano
                    },
                    {
                        title: `Realizar Fluxo de Caixa`,
                        description: `Foram realizadas lançamento de parcelas para o job ${this.selectedProject.code}`,
                        link: '',
                        view: 'Não',
                        schemaRecordId: this.selectedProject.id,
                        user: 'f7245c6d-992b-409e-9fe6-9106dc0b3e1c' // Ryan Marck Loures de Novais
                    },
                    {
                        title: `Realizar Fluxo de Caixa`,
                        description: `Foram realizadas lançamento de parcelas para o job ${this.selectedProject.code}`,
                        link: '',
                        view: 'Não',
                        schemaRecordId: this.selectedProject.id,
                        user: 'fa96c8e3-b570-4b35-b87d-bcc742de099c' // Vinicius Avelino da Silva
                    },
                    {
                        title: `Realizar Fluxo de Caixa`,
                        description: `Foram realizadas lançamento de parcelas para o job ${this.selectedProject.code}`,
                        link: '',
                        view: 'Não',
                        schemaRecordId: this.selectedProject.id,
                        user: '62b2a00c-376e-420b-aa97-c47264c324f7' // Gerson Mariano de Souza
                    }
                ])

            }

            if (response.data.success) {
                this.$notfy.success("Parcelas salvas com sucesso.")
                this.itemsParcelas = []
                this.$emit('save')
            } else {
                this.$notfy.error("Erro ao salvar as parcelas.")
            }
        },

        async verifySelectedProject(){

            if(!this.selectedProject) return

            if(!this.selectedProject.condicaoDePagamento){
                this.$notfy.error("JOB não possui condições de pagamento.")
                this.itemsParcelas = []
                this.selectedProject = null
                return
            }

            // page, limit, search, searchFields, ids, mode, companySiteId, sortField
            let response = await this.entityServiceParcelas.getAll(1, 1000, this.selectedProject?.id, 'job', null, null, null, 'parcelaSequencia')
            let parcela = response.data.data.data
            this.itemsParcelas = []

            if(parcela.length > 0){
                let sum = 0
                parcela.forEach((item) => {
                    sum += Number(item.parcelaPorcentagem)
                })

                if(sum >= 100){
                    this.$notfy.error("Parcela já atingiu 100%.")
                }

                parcela.map((parcela) => {

                    console.log('PARCELA >>> ', parcela)
                    
                    this.itemsParcelas.push({
                        code: parcela.code,
                        parcelaSequencia: parcela.parcelaSequencia,
                        tipo: parcela.tipo,
                        descricao: parcela.descricao,
                        parcelaDias: parcela.parcelaDias,
                        dataVencimento: moment(parcela.dataVencimento).format('YYYY-MM-DD'),
                        dataPrevisao: moment(parcela.dataPrevisao).format('YYYY-MM-DD'),
                        parcelaPorcentagem: parcela.parcelaPorcentagem,
                        vrlParcela: parcela.vrlParcela * 100,
                        id: parcela.id
                    })
                })
            } else {
                let code = await this.getJobCode()

                this.itemsParcelas.push({
                    code,
                    //parcelaSequencia: 1,
                    tipo:'PV',
                    descricao: '',
                    parcelaDias: 0,
                    dataVencimento: '',
                    dataPrevisao: '',
                    parcelaPorcentagem: 0,
                    vrlParcela: '',
                })
            }
        },

        calcPercentage(item){
            let valor = String(item.parcelaPorcentagem)
            .replace(',', '.')        // troca vírgula por ponto
            .replace(/[^0-9.]/g, '')  // remove tudo que não for número/ponto

            let num = parseFloat(valor)

            if (isNaN(num)) num = 0
            if (num > 100) num = 100


            if(Number(item.parcelaPorcentagem) > 100){
                this.$notfy.error("Erro, não pode ultrapassar 100%");
                item.parcelaPorcentagem = 0
                return
            }

            item.vrlParcela = (Number(num) / 100 * this.selectedProject?.valorJob).toFixed(2);
            item.parcelaPorcentagem = num.toFixed(2).replace('.', ',')

            this.sumTotValue("vrlParcela")
            this.componentKey += 1
        },
        
        calcValue(item){
            if(item.vrlParcela > this.selectedProject.valorJob){
                this.$notfy.error("Erro, não pode ultrapassar o valor do job.");
                item.vrlParcela = 0
                return
            }
            const rawValue = Number(
                String(item.vrlParcela)
                .replace(/[^0-9,-]+/g, '') // remove R$, espaços etc
                .replace('.', '')
                .replace(',', '.')
            )

            item.parcelaPorcentagem = (((rawValue) / this.selectedProject.valorJob) * 100).toFixed(2);
            this.sumTotValue("parcelaPorcentagem")
            this.componentKey += 1
        },

        sumTotValue(type){
            this.totValue = 0;

            this.itemsParcelas.forEach(item => {
                const rawValue = Number(
                    String(item.vrlParcela)
                    .replace(/[^0-9,-]+/g, '') // remove R$, espaços etc
                    .replace(/\./g, '')         // remove todos os pontos
                    .replace(',', '.')          // troca vírgula por ponto
                );
                type == 'parcelaPorcentagem' ? this.totValue += rawValue : this.totValue += rawValue / 100;
            });
        },

        calcDays(value){
            value.dataVencimento = moment().add(Number(value.parcelaDias), 'days').format("YYYY-MM-DD")
        },

        calcDaysDate(value){
            value.parcelaDias = moment(value.dataVencimento).diff(moment(), 'days') + 1
        }
    },
    watch: {
        async open(val) {
            this.dialog = val

            if(val){
                this.getJobs()
            } else {
                this.itemsParcelas = []
                this.selectedProject = null
            }
        }
    },
    async mounted() {
        this.getJobs()
    },
}
</script>

<style scoped>
    .custom-dialog {
        top: 50% !important;
        transform: translateY(-50%) !important;
    }

    .job-search-container {
        margin-left: 88px;
        margin-bottom: 20px;
    }

    .job-search-container  span, .tot-field-container span {
        font-size: 12px;
    }

    .job-field {
        width: 150px;
    }

    .tot-field-container {
        margin-left: 10px;
    }
</style>